var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Order_By } from '../../models/GQLGeneratedModels';
import { useGetAssembliesByAPIQuery } from '../../services/AssemblyService';
import { ApplicationContext } from '../ApplicationProvider';
import { ConfigitContext } from '../ConfigitProvider';
import { COMPONENT_MAP } from '../constants/COMPONENT_MAP';
import { TableComponent } from '../shared/TableComponent/TableComponent';
import { ErrorModalComponent } from '../shared/ErrorModalComponent/ErrorModalComponent';
import { Dialog } from '../shared/DialogComponent/Dialog';
import { isRNDM } from '../../utils/RNDMUtilities';
import { ExportToCsvConverter } from './ExportToCsvConverter';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var AssemblyView = function (_a) {
    var count = _a.count;
    var _data$navassembly_api;
    var navigate = useNavigate();
    var location = useLocation();
    var urlParams = new URLSearchParams(location.search);
    var _b = useContext(ApplicationContext), itemOffset = _b.itemOffset, itemsPerPage = _b.itemsPerPage, setItemOffset = _b.setItemOffset, setItemsPerPage = _b.setItemsPerPage, filters = _b.filters, setDialog = _b.setDialog, showDialog = _b.showDialog, setShowDialog = _b.setShowDialog;
    var _c = useContext(ConfigitContext), layers = _c.layers, manufacturerProduct = _c.manufacturerProduct, excludedLayerIds = _c.excludedLayerIds;
    var _d = useContext(ApplicationContext), triggerAssemblyList = _d.triggerAssemblyList, setTriggerAssemblyList = _d.setTriggerAssemblyList;
    var _e = useContext(ApplicationContext), numShowResult = _e.numShowResult, setNumShowResult = _e.setNumShowResult;
    var _f = useState(isRNDM ? COMPONENT_MAP.PrivateAssemblyView.colHeads : COMPONENT_MAP.AssemblyView.colHeads), columnHeaders = _f[0], setColumnHeaders = _f[1];
    var _g = useState('Assembly #'), fieldSort = _g[0], setFieldSort = _g[1];
    var _h = useState('asc'), sortDir = _h[0], setSortDir = _h[1];
    var _j = useState({ AssemblyId: Order_By.Asc, CoverSubassemblyId: Order_By.Asc, DeckSubassemblyId: Order_By.Asc }), orderbyInfo = _j[0], setOrderbyInfo = _j[1];
    var _k = useGetAssembliesByAPIQuery(layers, excludedLayerIds, manufacturerProduct, itemsPerPage, itemOffset, orderbyInfo, filters), data = _k.data, loading = _k.loading, error = _k.error;
    useEffect(function () { if (error) {
        setDialog(/*#__PURE__*/ _jsx(Dialog, { label: "An Error Occurred", children: /*#__PURE__*/ _jsx(ErrorModalComponent, {}) }));
        setShowDialog(true);
    } }, [error]);
    var navigateToDetail = function (navAssemblyId, e) { if (e && e.ctrlKey) {
        window.open("/assemblyDetail/".concat(navAssemblyId, "?").concat(urlParams.toString()), "_blank");
    }
    else {
        navigate("/assemblyDetail/".concat(navAssemblyId, "?").concat(urlParams.toString()));
    } }; // Invoke when user click to change different page size
    var handlePageSizeChange = function (event) {
        var newPageSize = parseInt(event.target.value);
        setItemsPerPage(newPageSize);
        setItemOffset(0); // Reset to be the first page
        setTriggerAssemblyList(true);
        setNumShowResult(numShowResult + 1);
    }; // Invoke when user click to request another page.
    var handlePageClick = function (event) { return __awaiter(void 0, void 0, void 0, function () { var newOffset; return __generator(this, function (_a) {
        if (!count)
            return [2 /*return*/];
        newOffset = event.selected * itemsPerPage % count;
        setItemOffset(newOffset);
        setTriggerAssemblyList(true);
        setNumShowResult(numShowResult + 1);
        return [2 /*return*/];
    }); }); };
    var handleSort = function (field) {
        var headers = isRNDM ? __spreadArray([], COMPONENT_MAP.PrivateAssemblyView.colHeads, true) : __spreadArray([], COMPONENT_MAP.AssemblyView.colHeads, true);
        var newSortDir;
        if (fieldSort === field) {
            newSortDir = sortDir === 'asc' ? 'desc' : 'asc';
            for (var i = 0; i < headers.length; i++) {
                if (headers[i].className !== 'notvisible') {
                    if (headers[i].name === field) {
                        headers[i].className = newSortDir === 'asc' ? 'th-inner sortable both sorted asc' : 'th-inner sortable both sorted desc';
                    }
                    else {
                        headers[i].className = 'th-inner sortable both unsorted';
                    }
                }
            }
        }
        else {
            newSortDir = 'asc';
            for (var i = 0; i < headers.length; i++) {
                if (headers[i].className !== 'notvisible') {
                    if (headers[i].name === field) {
                        headers[i].className = 'th-inner sortable both sorted asc';
                    }
                    else {
                        headers[i].className = 'th-inner sortable both unsorted';
                    }
                }
            }
        } // Get order_by variable
        var orderBy;
        var orderByType = newSortDir === 'asc' ? Order_By.Asc : Order_By.Desc;
        switch (field) {
            case 'Assembly #': //orderBy = { NavAssemblyName: orderByType };
                orderBy = { AssemblyId: orderByType, CoverSubassemblyId: orderByType, DeckSubassemblyId: orderByType };
                break;
            case 'Cover': //orderBy = { AssemblyTypeId: orderByType };
                //orderBy = { RoofAssembly: { C_AssemblyType: { AssemblyTypeCode: orderByType } } };
                orderBy = { AssemblyTypeCode: orderByType };
                break;
            case 'Application': //orderBy = { AssemblyApplicationTypeId: orderByType };
                //orderBy = { RoofAssembly: { C_AssemblyApplicationType: { AssemblyApplicationTypeCode: orderByType } } };
                orderBy = { AssemblyApplicationTypeCode: orderByType };
                break;
            case 'Securement': //orderBy = { CoverSecurementMethodId: orderByType };
                //orderBy = { RoofAssembly: { C_CoverSecurementMethod: { CoverSecurementMethodCode: orderByType } } };
                orderBy = { CoverSecurementMethodCode: orderByType };
                break;
            case 'Deck': //orderBy = { DeckTypeId: orderByType };
                //orderBy = { RoofAssembly: { C_DeckType: { DeckTypeCode: orderByType } } };
                orderBy = { DeckTypeCode: orderByType };
                break;
            case 'Wind Uplift': //orderBy = { WindUplift: orderByType };
                orderBy = { WindUpliftValue: orderByType };
                break;
            case 'I/Fire': //orderBy = { IntFireRatingId: orderByType };
                //orderBy = { RoofAssembly: { C_IntFireRating: { IntFireRatingCode: orderByType } } };
                orderBy = { IntFireRatingCode: orderByType };
                break;
            case 'E/Fire': //orderBy = { ExtFireRatingId: orderByType };
                //orderBy = { RoofAssembly: { C_ExtFireRating: { ExtFireRatingCode: orderByType } } };
                orderBy = { ExtFireRatingCode: orderByType };
                break;
            case 'Slope': //orderBy = { Slope: orderByType };
                orderBy = { SlopeValue: orderByType };
                break;
            case 'Hail': //orderBy = { HailRatingId: orderByType };
                //orderBy = { RoofAssembly: { C_HailRating: { HailRatingCode: orderByType } } };
                orderBy = { HailRatingCode: orderByType };
                break;
            case 'Status':
                orderBy = { StatusId: orderByType };
                break;
            case 'Lock':
                orderBy = { LockStatusCode: orderByType };
                break;
            default: //orderBy = { NavAssemblyName: Order_By.Asc };
                orderBy = { AssemblyId: Order_By.Asc, CoverSubassemblyId: Order_By.Asc, DeckSubassemblyId: Order_By.Asc };
        }
        setOrderbyInfo(orderBy);
        setFieldSort(field);
        setSortDir(newSortDir);
        setColumnHeaders(headers);
        setTriggerAssemblyList(true);
        setNumShowResult(numShowResult + 1);
    };
    return /*#__PURE__*/ _jsxs("div", { id: "roofnav_results", className: "p-3", children: [isRNDM ? /*#__PURE__*/ _jsx(ExportToCsvConverter, {}) : null, /*#__PURE__*/ _jsx(TableComponent, { loading: loading, count: count, offset: itemOffset, limit: itemsPerPage, handlePageSizeChange: handlePageSizeChange, handlePageClick: handlePageClick, handleSort: handleSort, colHeads: columnHeaders, navigateToDetail: navigateToDetail, rows: data && ((_data$navassembly_api = data.navassembly_api_search) === null || _data$navassembly_api === void 0 ? void 0 : _data$navassembly_api.map(function (navAssembly) { var row = []; row.push(navAssembly === null || navAssembly === void 0 ? void 0 : navAssembly.NavAssemblyId.toString()); row.push(navAssembly === null || navAssembly === void 0 ? void 0 : navAssembly.NavAssemblyName); if (isRNDM) {
                    row.push((navAssembly === null || navAssembly === void 0 ? void 0 : navAssembly.StatusId.toString()) === '3' ? 'Delisted' : 'Active');
                    row.push(navAssembly === null || navAssembly === void 0 ? void 0 : navAssembly.LockStatusCode);
                } ; row.push(navAssembly === null || navAssembly === void 0 ? void 0 : navAssembly.AssemblyTypeCode); row.push(navAssembly === null || navAssembly === void 0 ? void 0 : navAssembly.AssemblyApplicationTypeCode); row.push(navAssembly === null || navAssembly === void 0 ? void 0 : navAssembly.CoverSecurementMethodCode); row.push(navAssembly === null || navAssembly === void 0 ? void 0 : navAssembly.DeckTypeCode); row.push(navAssembly === null || navAssembly === void 0 ? void 0 : navAssembly.WindUplift.toString()); row.push((navAssembly === null || navAssembly === void 0 ? void 0 : navAssembly.IntFireRatingCode).trim()); row.push(navAssembly === null || navAssembly === void 0 ? void 0 : navAssembly.ExtFireRatingCode); row.push(navAssembly === null || navAssembly === void 0 ? void 0 : navAssembly.Slope.toString()); row.push(navAssembly === null || navAssembly === void 0 ? void 0 : navAssembly.HailRatingCode); return row; })) }), /*#__PURE__*/ _jsx("div", { className: "clearfix" })] });
};
